/*@ngInject*/
const ClassCodeController = function ($rootScope, $scope, $controller, formViewerConstant, formComponentUtil, xmlUtil,
                                      formMediator, localization, coreMediator, coreConstant, appTypeConfigurationModel, browserUtil) {

    let splitKey = '::',
        itemHelper = {helper: true, 'description': null},
        itemNoResult = {helper: true, 'description': null},
        minTextSearchLength = 3,
        minWidth = 150,
        currencyCode,
        inStudio = false;

    angular.extend(this,
        $controller('baseFormComponentController', {$scope: $scope}),
        $controller('baseDataSetFormComponentController', {$scope: $scope}));

    this.$onInit = function () {
        let consoleType = appTypeConfigurationModel.getConsoleType();
        this.dropdownSelectedValue = null;
        this.itemsList = [];

        this.stateList = [ {code: ''} ];
        this.stateDropdownSelectedValue = null;
        this.isStateClassCode = false;
        this.showStateLoadingSpinner = false;
        this.stateClassCodeDropdownUnselectItemIdentifier = 'stateClassCodeDropdown';

        this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);

        if (!_.isNil(this.formStructure)) {
            this.effectiveDate = this.formStructure.effectiveDate;
            currencyCode = this.formStructure.currencyCode;
        }

        localization.getTranslationByKey('formsViewer.controls.umsClassCodeFinder').then(function (translations) {
            itemHelper.description = _.replace(_.get(translations, 'itemHelper'), '{0}', minTextSearchLength);
            itemNoResult.description = _.get(translations, 'noResults');
        });
        this.fieldOptions = this.fieldStructure.uiField.options ? xmlUtil.parseString(this.fieldStructure.uiField.options) : {};
        this.placeholder = this.fieldOptions.classCodeLabel;
        this.classCodeType = this.fieldOptions.classCodeType || 'NCCI';
        this.clearItemsList();

        if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO) {
            formComponentUtil.setupFieldProperties(this.fieldStructure, currencyCode);
            inStudio = true;
        }

        this.areStatesLoaded = false;

        formMediator.getClassCodeFormat(this.classCodeType).then((format) => {
            this.isStateClassCode = format.indexOf('{state}') !== -1;

            if (this.isStateClassCode) {
                if (this.fieldStructure.layout.inputWidth < minWidth) {
                    this.fieldStructure.layout.inputWidth = minWidth;
                    this.fieldStructure.uiField.minWidth = minWidth;
                }

                this.updateStateDropdownSelectedValue();
            }

            this.updateDropdownSelectedValue();
        });

        this.configurationClass = this.fieldStructure.isConfigurableComponent ? 'configurableComponent' : '';
        this.initialized = true;
    };

    this.$onChanges = function () {
        this.onChanges();
        if(this.initialized) {
            this.updateStateDropdownSelectedValue();
            this.updateDropdownSelectedValue();
        }
    };

    this.setStateItemsList = function (stateList) {
        this.stateList = _.cloneDeep(stateList);
    };

    this.handleStateFocus = function () {
        if (!this.areStatesLoaded && (_.isNil(this.fieldStructure.parentFormStructure) || !this.fieldStructure.parentFormStructure.isConfigurableForm)) {
            this.showStateLoadingSpinner = true;
            formMediator.getClassCodeGroupings(this.classCodeType, this.effectiveDate).then((result) => {
                this.setStateItemsList(result);
                this.areStatesLoaded = true;
                this.updateStateDropdownSelectedValue();

                $rootScope.$broadcast(coreConstant.event.HIDE_FORM_TOOLTIP);
            }).finally(() => {
                this.showStateLoadingSpinner = false;
            });
        }
    };

    this.loadItemsList = function (query) {
        let searchTerm,
            adjustedSearchLength = minTextSearchLength;

        if (this.isStateClassCode) {
            searchTerm = (this.stateDropdownSelectedValue ? this.stateDropdownSelectedValue.code : '') + query;
            adjustedSearchLength += 2;
        }
        else {
            searchTerm = query;
        }

        const processClassCodeItems = (result) => {
            if (result.length === 0) {
                this.itemsList = [ itemNoResult ];
            }
            else {
                this.itemsList = result;
            }
        }

        if (searchTerm.length >= adjustedSearchLength) {
            if(inStudio) {
                formMediator.getClassCodeItemsNoDate(this.classCodeType, searchTerm).then(processClassCodeItems);
            }
            else {
                formMediator.getClassCodeItems(this.classCodeType, searchTerm, this.effectiveDate).then(processClassCodeItems);
            }
        }
        else {
            this.clearItemsList(query.length);
        }
    };

    this.handleSelect = function () {
        this.fieldStructure.hasLocalChanges = true;

        if (!this.fieldStructure.fieldModel) {
            this.fieldStructure.fieldModel = {};
        }

        if (this.dropdownSelectedValue) {
            this.fieldStructure.fieldModel.value = _.get(this.dropdownSelectedValue, 'code') + splitKey;
            this.fieldStructure.fieldModel.valueLabel = _.get(this.dropdownSelectedValue, 'value');

            $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
        }
        else {
            this.fieldStructure.fieldModel.value = (this.stateDropdownSelectedValue ? this.stateDropdownSelectedValue.code : '');
            this.fieldStructure.fieldModel.valueLabel = '';
            this.fieldStructure.dynamicProperties.tooltip.message = this.fieldStructure.uiField.tooltipText;
            this.clearItemsList(0);
        }

        formComponentUtil.setupFieldProperties(this.fieldStructure, currencyCode);

        if (!_.isNil(this.onSelect)) {
            this.onSelect({classCodeValue: this.fieldStructure.fieldModel.value});
        }
        else {
            formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this));
        }
        if (browserUtil.isIE11() || browserUtil.isEdge()) {
            $scope.$broadcast(coreConstant.event.classCode.HIDE_TOOLTIP);
        }
    };

    this.getCurrentValue = function () {
        let result = '',
            value;

        if (!_.isNil(this.dropdownSelectedValue) && !_.isNil(this.dropdownSelectedValue.codeDisplayText)) {
            result = this.dropdownSelectedValue.codeDisplayText;
        }
        else {
            if (this.fieldStructure.dynamicProperties.hasValue) {
                value = _.replace(_.get(this.fieldStructure, 'fieldModel.value'), splitKey, '');

                if (this.isStateClassCode) {
                    result = value.slice(3, value.length);
                }
                else {
                    result = value;
                }
            }
        }

        return result;
    };

    this.clearItemsList = function (queryLength) {
        let helper = _.clone(itemHelper);

        queryLength = queryLength || 0;

        if (this.fieldStructure.dynamicProperties.tooltip) {
            helper.description = this.fieldStructure.dynamicProperties.tooltip.message;
        }

        this.itemsList = [ helper ];

        $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, null);
    };

    this.updateStateDropdownSelectedValue = function () {
        let value,
            stateCode,
            selectedStateCode,
            selectedStateCodeValueIndex;

        if (this.fieldStructure.dynamicProperties.hasValue && this.isStateClassCode) {
            stateCode = this.fieldStructure.fieldModel.value.slice(0, 2);

            selectedStateCodeValueIndex = _.findIndex(this.stateList, {code: stateCode});
            $scope.$broadcast(formViewerConstant.event.DROPDOWN_UPDATE_ACTIVE_INDEX, selectedStateCodeValueIndex);

            if (selectedStateCodeValueIndex !== -1) {
                selectedStateCode = this.stateList[ selectedStateCodeValueIndex ];
            }

            if (_.isNil(selectedStateCode)) {
                this.stateDropdownSelectedValue = {
                    code: stateCode
                };
            }
            else {
                this.stateDropdownSelectedValue = selectedStateCode;
            }

            this.skipStateMaskOnClassCodeSelector = !this.stateDropdownSelectedValue && !this.fieldStructure.dynamicProperties.isValid;
        }
        else {
            this.stateDropdownSelectedValue = null;
        }

        $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.stateDropdownSelectedValue, this.stateClassCodeDropdownUnselectItemIdentifier);
    };

    this.updateDropdownSelectedValue = function () {
        let fieldInstance = this.fieldStructure.fieldModel,
            value,
            stateCode,
            description,
            hasClassCode,
            selectedStateCode,
            selectedStateCodeValueIndex;

        if (this.fieldStructure.dynamicProperties.hasValue) {
            value = _.replace(fieldInstance.value, splitKey, '');
            description = value;
            hasClassCode = !this.isStateClassCode || value.length > 2;
            stateCode = description.slice(0, 2);

            if (hasClassCode) {
                formMediator.getClassCodeItems(this.classCodeType, value, this.effectiveDate).then((result) => {
                    let classCode;

                    if (_.size(result) === 1) {
                        classCode = result[ 0 ];

                        if (_.isEmpty(fieldInstance.valueLabel)) {
                            fieldInstance.valueLabel = classCode.value;
                        }
                    }

                    if (!_.isEmpty(fieldInstance.valueLabel)) {
                        description += ' - ' + fieldInstance.valueLabel;
                    }

                    this.dropdownSelectedValue = {
                        value: fieldInstance.valueLabel || fieldInstance.value,
                        code: value,
                        description: description,
                        tooltip: description
                    };

                    if (!_.isNil(classCode) && !_.isNil(classCode.codeDisplayText)) {
                        this.dropdownSelectedValue.description = classCode.description;
                        this.dropdownSelectedValue.codeDisplayText = classCode.codeDisplayText;
                        this.dropdownSelectedValue.tooltip = (this.isStateClassCode ? stateCode + ' ' : '') + this.dropdownSelectedValue.description;
                    }
                });
            }
        }
        else {
            this.dropdownSelectedValue = null;
        }

        $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
    };

    this.handleStateSelect = function () {
        this.dropdownSelectedValue = null;
        this.clearItemsList();
        this.handleSelect();

        $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.stateDropdownSelectedValue, this.stateClassCodeDropdownUnselectItemIdentifier);

        $scope.$emit(coreConstant.event.ADVANCE_FOCUS, '.classCodeComponent .classCodeComponentSelect .ui-select-match');
    };

    this.getItemDescription = function (item) {
        let result = '';

        if (item && this.isStateClassCode && !this.skipStateMaskOnClassCodeSelector) {
            result = item.helper || !_.isNil(item.codeDisplayText) ? item.description : item.description.slice(2, item.description.length);
        }
        else if (item) {
            result = item.description;
        }

        return result;
    };

    this.getRowNumberClass = function () {
        let rowNumberClass = '';

        if (!_.isNil(this.fieldStructure.rowNumber)) {
            rowNumberClass = `row${this.fieldStructure.rowNumber}`;
        }

        return rowNumberClass;
    }
};

angular.module('umFormViewer')
    .controller('classCodeController', ClassCodeController);
